module.exports = __webpack_public_path__ + "830718a4e7eab5941d76fa62eeaf37ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/news/img2.jpg
// module id = 538
// module chunks = 0